import { GestureTapIcon } from './GestureTapIcon';

/**
 * author: Michael Richins
 * id D881AFBC-7477-46C2-9269-324676F19E51
 * name gesture-tap
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gesture-tap.svg
 * tags
 */
export const GestureTouchIcon = GestureTapIcon;
export default GestureTouchIcon